import { useEffect, FC } from 'react';
import { useUserAuth } from '~/components/Auth';
import { isEmpty } from '@mindtickle/utils';
import { reload } from '@mindtickle/utils/url';

interface TempFeatureConfig {
  react_dashboard?: boolean;
}

const LegacyNavigator: FC = () => {
  const { tempFeatureConfig = {} as TempFeatureConfig } = useUserAuth();
  const { react_dashboard } = tempFeatureConfig;

  useEffect(() => {
    let reactDashboard = react_dashboard;
    if (isEmpty(reactDashboard)) {
      reactDashboard = true;
    }
    if (!reactDashboard) {
      reload('/');
    }
  }, [react_dashboard]);

  return null;
};

export default LegacyNavigator;
